import { createPermissionHook } from 'expo-modules-core';
import {
  NotificationPermissionsRequest,
  NotificationPermissionsStatus,
  getPermissionsAsync,
  requestPermissionsAsync,
} from 'expo-notifications';

// WARNING: This was removed from expo-notifications (Not exactly sure why)
// https://github.com/expo/expo/pull/31905/files
export const usePushPermissions = createPermissionHook<
  NotificationPermissionsStatus,
  NotificationPermissionsRequest
>({
  requestMethod: requestPermissionsAsync,
  getMethod: getPermissionsAsync,
});
